import { request } from '@helpers/fetch';
import { ArticlesFilter, GetArticlesResponse } from '@models/articles';
import { Response } from '@models/response';

export const apiArticles = {
  getArticles(payload: ArticlesFilter): Promise<Response<GetArticlesResponse>> {
    return request.get('/api/v1/articles', payload);
  },
};
